import {Component, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Employee } from '../models/employee.model';
import { EmployeeService } from '../services/employee.service';
import { SickLeaveRequest, SickLeaveService } from '../services/sick-leave.service';
import { DatevAuthStatusService } from '../services/datev-auth-status.service';
import { Signal } from '@angular/core';
import { buildSickLeaveForm, attachEndDateValidator, buildSickLeaveRequest } from '../shared/sick-leave-form.util';

@Component({
    selector: 'app-sick-leave-form',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: './sick-leave-form.component.html',
    styleUrls: ['./sick-leave-form.component.css']
})
export class SickLeaveFormComponent implements OnInit {
    sickLeaveForm: FormGroup;
    employees: Employee[] = [];
    employeeSignal: Signal<Employee[]>;

    constructor(
        private fb: FormBuilder,
        private employeeService: EmployeeService,
        private sickLeaveService: SickLeaveService,
        private router: Router,
        public datevAuthService: DatevAuthStatusService
    ) {
        // employeeId ist nur hier nötig (die volle Seite muss den Mitarbeiter erst auswählen
        // lassen, das Modal kennt ihn bereits über @Input) - daher auf der gemeinsamen
        // Basis-Form ergänzt statt Teil von buildSickLeaveForm() zu sein.
        this.sickLeaveForm = buildSickLeaveForm(this.fb);
        this.sickLeaveForm.addControl('employeeId', this.fb.control('', Validators.required));

        this.employeeSignal = this.employeeService.getEmployees();
    }

    ngOnInit() {
        this.employees = this.employeeService.getEmployees()().map((emp: Employee) => ({
            ...emp,
            employeeId: emp.datevEmployeeNumber
        }));

        attachEndDateValidator(this.sickLeaveForm);
    }

    onSubmit() {
        if (this.sickLeaveForm.valid) {
            const request: SickLeaveRequest = buildSickLeaveRequest(
                this.sickLeaveForm,
                Number(this.sickLeaveForm.value.employeeId)
            );

            this.sickLeaveService.createSickLeave(request)
                .subscribe({
                    next: () => {
                        this.router.navigate(['/sick-leave/confirmation'], {
                            queryParams: {
                                message: 'Die Krankmeldung wurde erfolgreich im System gespeichert.'
                            }
                        });
                    },
                    error: (error) => {
                        console.error('Error submitting sick leave:', error);
                        this.router.navigate(['/sick-leave/confirmation'], {
                            queryParams: {
                                error: true,
                                message: error.error?.message || 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'
                            }
                        });
                    }
                });
        }
    }

    loginDatev() {
        this.datevAuthService.loginDatev();
    }
}